export class API {
	constructor(origin) {
		this.url = origin + `/safire/api/`;
	}
	SACode(version, namespace, sacode, args) {
		return fetch(this.url + `sacode/${encodeURIComponent(version)}/${encodeURIComponent(namespace)}/${encodeURIComponent(sacode)}`, args).then(res=>res.json());
	}
	SCC(version, namespace, scc, args) {
		return fetch(this.url + `scc/${encodeURIComponent(version)}/${encodeURIComponent(namespace)}/${encodeURIComponent(scc)}`, args).then(res=>res.json());
	}
}